import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../models/report.model';
import { PhotoService } from '../../services/photo.service';
import { EditorRoles } from '../../models/editor-roles-http.dto';

@Component({
  selector: 'app-expert-immobilier',
  templateUrl: './expert-immobilier.component.html',
  styleUrls: ['./expert-immobilier.component.scss'],
})
export class ExpertImmobilierComponent implements OnChanges {
  @Input() expert!: Report.Expert;
  @Input() reportId!: string;
  @Input() isLoading = false;
  @Input() roles!: EditorRoles;

  expertInternal!: Report.Expert;
  exportPhoto!: string;

  @Output() expertChanged = new EventEmitter<Report.Expert>();
  @Output() expertEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  constructor(private readonly photoService: PhotoService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.changes(changes);
  }

  private async changes(changes: SimpleChanges) {
    if (changes['expert']?.currentValue) {
      this.exportPhoto = await this.photoService.getExpertPhoto(this.reportId);
    }
  }

  onExpertChanged(expertInternal: Report.Expert): void {
    this.expertInternal = expertInternal;
  }

  onSaveSection(): void {
    this.expertChanged.emit(this.expertInternal);
  }

  onEnabled(isEnabled: boolean): void {
    this.expertEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.cancled.emit();
  }
}
